const FolderIcon = (props: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      className={props.className}
    >
      <path
        d="M16.5 17.3334V28"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83313 19.8653C4.84252 18.8532 4.09523 17.6289 3.64785 16.2852C3.20047 14.9415 3.06474 13.5136 3.25095 12.1097C3.43715 10.7058 3.94041 9.36265 4.72259 8.18203C5.50478 7.00141 6.54538 6.01427 7.76558 5.29539C8.98578 4.5765 10.3536 4.14472 11.7654 4.03276C13.1771 3.92079 14.5959 4.13157 15.9142 4.64913C17.2324 5.1667 18.4156 5.97747 19.3741 7.02004C20.3326 8.0626 21.0413 9.30963 21.4465 10.6667H23.8331C25.1205 10.6665 26.3737 11.0804 27.4078 11.8472C28.4418 12.6141 29.2018 13.6931 29.5755 14.9251C29.9492 16.157 29.9167 17.4764 29.4829 18.6885C29.0491 19.9005 28.237 20.9409 27.1665 21.656"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1665 22.6667L16.4998 17.3334L21.8332 22.6667"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FolderIcon;
